export const EVENTS_TABLE_PER_PAGE_KEY = 'eventPaginatedTable.perPage';
